function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStatus = function SvgStatus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), React.createElement("title", null, title), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("circle", {
    style: {
      fill: "#FFC200"
    },
    cx: 256,
    cy: 256,
    r: 256
  })))))))))))), React.createElement("path", {
    style: {
      fill: "#FF9500"
    },
    d: "M511.595,256c0-5.63-0.202-11.212-0.56-16.751l-84.729-84.729l-22.785,8.153l-98.854-98.854   L63.818,304.667l103.686,103.686l-12.985,17.953l85.189,85.19c5.256,0.322,10.549,0.505,15.886,0.505   C396.979,512,511.595,397.385,511.595,256z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#555A66"
    },
    d: "M448.182,304.667v-97.333h-39.798c-2.731-8.558-6.159-16.804-10.224-24.668l28.146-28.146    L357.48,85.694l-28.146,28.146c-7.865-4.065-16.11-7.493-24.668-10.224V63.818h-97.333v39.798    c-8.558,2.731-16.804,6.159-24.668,10.224l-28.146-28.146l-68.825,68.825l28.146,28.146c-4.065,7.865-7.493,16.11-10.224,24.668    H63.818v97.333h39.798c2.731,8.558,6.159,16.804,10.224,24.668L85.694,357.48l68.825,68.825l28.146-28.146    c7.864,4.065,16.11,7.493,24.668,10.224v39.798h97.333v-39.798c8.558-2.731,16.804-6.159,24.668-10.224l28.146,28.146    l68.825-68.825l-28.146-28.146c4.065-7.864,7.493-16.11,10.224-24.668H448.182z"
  })), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#333940"
    },
    d: "M448.182,304.667v-97.333h-39.798c-2.731-8.558-6.159-16.804-10.224-24.668l28.146-28.146    L357.48,85.694l-28.146,28.146c-7.865-4.065-16.11-7.493-24.668-10.224V63.818h-48.762v384.363h48.762v-39.798    c8.558-2.731,16.804-6.159,24.668-10.224l28.146,28.146l68.825-68.825l-28.146-28.146c4.065-7.865,7.493-16.11,10.224-24.668    H448.182z"
  })), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 256,
    cy: 256,
    r: 130.754
  })))))))))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#E9EDF5"
    },
    d: "M256,125.246c-0.032,0-0.063,0.001-0.095,0.001v261.505c0.032,0,0.063,0.001,0.095,0.001              c72.213,0,130.754-58.54,130.754-130.754S328.213,125.246,256,125.246z"
  })))))))))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#FF432E"
    },
    d: "M352.75,312.601l-25.646-15.564c7.849-12.933,11.997-27.816,11.997-43.039              c0-45.822-37.278-83.1-83.101-83.1s-83.101,37.279-83.101,83.1h-30c0-62.364,50.736-113.1,113.101-113.1              s113.101,50.737,113.101,113.1C369.101,274.71,363.446,294.975,352.75,312.601z"
  })))))))))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#DB0404"
    },
    d: "M256,140.897c-0.032,0-0.063,0.001-0.095,0.001v30.001c0.032,0,0.063-0.002,0.095-0.002              c45.822,0,83.101,37.279,83.101,83.1c0,15.223-4.148,30.106-11.997,43.039l25.646,15.564              c10.696-17.626,16.351-37.891,16.351-58.603C369.101,191.634,318.364,140.897,256,140.897z"
  })))))))))))), React.createElement("g", null, React.createElement("rect", {
    x: 276.24,
    y: 236.704,
    transform: "matrix(0.689 -0.7248 0.7248 0.689 -121.2732 302.0094)",
    style: {
      fill: "#555A66"
    },
    width: 30,
    height: 111.197
  })), React.createElement("g", null, React.createElement("polygon", {
    style: {
      fill: "#333940"
    },
    points: "341.872,319.735 261.276,243.125 255.905,248.777 255.905,279.409 321.204,341.479   "
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStatus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/status.fad725a2.svg";
export { ForwardRef as ReactComponent };